export default __webpack_public_path__ + "static/media/alianza1.479d326d.png";